module.exports = __webpack_public_path__ + "static/media/ios-refresh.428b5e91.svg";